<template>
  <div class="l-m-style">
    <div class="header">风格管理</div>
    <div class="body" :style="getHeightStyle()">
      <div class="item" v-for="(item, index) in StylesList" :key="index">
        <div
          class="item-img"
          @click="setProjectStyle(item)"
          :class="{ active: ProjectInfo.Style.componentName === item.componentName }"
          draggable="false"
        >
          <img class="img" :src="item.componentOverViewImg" alt="" />
        </div>
        <div class="item-name">{{ item.componentTitle }}</div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'LMStyle',
  components: {},
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapState({
      IndexInfo: state => state.IndexInfo,
      ProjectInfo: state => state.ProjectInfo,
      StylesList: state => state.StylesList,
      isMobile: state => state.isMobile,
    }),
  },
  methods: {
    ...mapMutations(['set_ProjectStyle', 'set_ProjectBackground', 'set_CurrentConfigration']),
    getHeightStyle() {
      return {
        height: this.$store.state.ClientViewSize.height - 80 + 'px',
      };
    },
    setProjectStyle(config) {
      console.log(config, '风格 config');
      this.set_ProjectStyle(config);
      this.set_CurrentConfigration(config);
      // 设置背景为图片
      let bk = {
        componentTitle: '图片背景',
        componentName: 'PictureBackground',
        componentOverViewImg: './img/backgrounds/PictureBackground.png',
        id: 'PictureBackground',
        style: {
          backgroundColor: 'green',
        },
        propertyData: {
          backgroundColor: {
            propertyComponentName: 'SingleColorSelector',
            configurationAccessKey: 'style',
            value: '#19242D',
            lable: '背景颜色',
          },
          backgroundOpicity: {
            propertyComponentName: 'ChartsOpicityConfiger',
            value: 1,
          },
          backgroundImage: {
            propertyComponentName: 'PicturesUploader',
            value: '',
            lable: '图片路径',
          },

          backgroundVideo: {
            // propertyComponentName: 'VideosUploader',
            value: '#',
            lable: '视频路径',
          },
        },
      };
      if (config.backgroundImg) {
        console.log('更换背景！！');
        if (this.isMobile) {
          bk.propertyData.backgroundImage.value = config.backgroundImgMobile;
        } else {
          bk.propertyData.backgroundImage.value = config.backgroundImg;
        }

        this.set_ProjectBackground(bk);
        this.set_CurrentConfigration(bk);
        // 保存 对应 风格背景
        localStorage.setItem('backgroundDefault', JSON.stringify(bk));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.l-m-style {
  width: 240px;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .header {
    width: 100%;
    height: 40px;
    line-height: 40px;
    white-space: nowrap;
    text-align: center;
    font-size: 14px;
    color: $font-color-base;
    user-select: none;
    background-color: #2c2e3f;
  }

  .body {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow-y: scroll;

    padding: 20px 0px 50px 0px;
    &::-webkit-scrollbar-thumb {
      background: #191e29 !important;
      width: 4px !important;
      height: 3px !important;
    }
    &::-webkit-scrollbar {
      width: 4px !important;
      height: 3px !important;
    }
    &::-webkit-scrollbar-track {
      background: #43455800;
    }

    .item-list {
      margin-bottom: 100px;
    }

    .item {
      margin: 0 auto;
      // background-color: rosybrown;
      width: 100%;
      height: 160px;
      // margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .item-img {
        overflow: hidden;
        cursor: pointer;
        width: 202px;
        height: 128px;
        box-sizing: border-box;
        background-color: rgba(20, 20, 27, 0.733);
        border: 1px solid rgba(0, 0, 0, 0);
        transition: border 0.2s;
        border-radius: 5px;
        &:hover {
          border: 1px solid rgb(59, 62, 226);
        }
        .img {
          width: 202px;
          height: 128px;
        }
      }
      .active {
        border: 1px solid rgb(76, 59, 226);
        // box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.692);
      }
      .item-name {
        user-select: none;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        color: $font-color-base;
      }
    }
  }
}
</style>
